<template>
  <div class="detial_item">
    <el-scrollbar style="height: 560px;">
      <div class="no_data" v-if="currentList.length==0">
        暂无数据
      </div>
      <template v-else>
        <div class="list" v-for="item in currentList" :key="item.id">
          <div class="detial_item"  v-if="currentTab==1" >
            <div class="header">
              <div class="name" style="cursor: pointer;" @click="getCompanyDetial(item.company_info.id)">{{ item.company_info.name }}</div>
              <el-button class="button" @click.stop="cancleApply(item.id)">取消投递</el-button>

            </div>
            <div class="content_box">
              <div class="left_box">
                <div class="job_name">{{ item.position_info.name }}</div>
                <div class="more_detial">
                  <span class="number">{{ item.position_info.salary }}</span>
                  <span class="background_label">{{ item.position_info.experience_type }}</span>
                  <span class="background_label">{{ item.position_info.degree }}</span>
                </div>
              </div>
              <div class="right_box">
                <div class="right_image_box">
                  <img :src="item.company_info.logo" alt="">
                </div>
                <div class="left_box">
                  <div class="job_name" style="cursor: pointer;" @click="getCompanyDetial(item.company_info.id)">{{  item.company_info.name}}</div>
                  <div class="more_detial">
                    <span class="background_label">{{ item.company_info.industry }}</span>
                    <span class="background_label">{{ item.company_info.staff_size }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="detial_item" v-else>
            <div class="header">
              <div class="name">{{ item.interview_contact_name }}
                <span style="margin-left: 15px; color: #FE574A;">5-16k</span>
                <span v-if="(currentTab==2) " class="status">{{item.status==0?'面试待接受':item.status==2?'面试已接受':item.status==3?'面试已拒绝':item.status==4?'面试未通过':'面试已通过'}}</span>
                <span v-if="(currentTab==3 || currentTab==4) " class="status" :class="currentTab==4?'no_status':''">{{currentTab==4?'面试未通过':'面试已通过'}}</span>
              </div>
              <div class="button_box" v-if="currentTab==2">
                <el-button class="button" :disabled="item.status!==0" :style="{opacity: item.status!==0?.8:1}" @click="getResumeStatus(item.id,2)">接受邀请</el-button>
                <el-button class="button  border_button" :disabled="item.status!==0" :style="{opacity: item.status!==0?.8:1}" @click="getResumeStatus(item.id,3)">拒绝邀请</el-button>
              </div>

            </div>
            <div class="content_box">
              <div class="left_box">
                <div class="job_name">{{ item.position_info.name }}</div>
                <div class="more_detial" style="color: #666666;">
                  <div class="image_box">
                    <img :src="item.company_info.logo" alt="">
                  </div>
                  <span style="cursor: pointer;" @click="getCompanyDetial(item.company_info.id)">{{ item.company_info.name }} </span>[{{item.company_info.industry}}·{{ item.company_info.staff_size }}]

                </div>
              </div>
              <div class="right_resume_box">
                <div class="time"> 面试时间：<span>{{ item.interview_time }}</span></div>
                <div class="time"> 面试地点：<span>{{ item.interview_address }}</span></div>
              </div>
            </div>

          </div>

        </div>
      </template>

    </el-scrollbar>
    <div class="pagination">
      <el-pagination background @current-change="handleCurrentChange" :current-page="params.page" :page-size="params.page_size" layout="total,  prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import { number } from "echarts/core";
import JobDetialItem from "./JobDetialItem.vue";
export default {
  name: "",
  props: ["currentTab"],
  data() {
    return {
      apiUrls: [
        "resumeApplyList",
        "resumeInterviewList",
        "resumeFeedbackList",
        "resumeFeedbackList",
      ],
      params: {
        page: 1,
        page_size: 10,
        type: 1,
      },
      currentList: [],
      total: 0,
      apiUrl: "resumeApplyList",
    };
  },
  watch: {
    currentTab: {
      handler(val) {
        this.currentList=[]
        this.apiUrl = this.apiUrls[val - 1];
        this.params.type = val == 3 ? 2 : 1;
        if (val == 1 || val == 2) delete this.params.type;
        this.getList();
      },
      immediate: true,
    },
  },
  components: {
    JobDetialItem,
  },
  mounted() {},
  methods: {
    getList() {
      this.$httpStudent.axiosGetBy(
        this.$api[this.apiUrl],
        this.params,
        (res) => {
          if (res.code === 200) {
            this.currentList = res.data.list;
            this.total = res.data.total;
            this.$message.success("获取成功");
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.getList();
    },
    // 取消投递
    cancleApply(id) {
      let params = {
        id: id,
      };
      this.$httpStudent.axiosPost(
        this.$api.resumeDeleteApply,
        params,
        (res) => {
          if (res.code === 200) {
            this.$message.success("取消成功");
            this.$emit("changeNUmber");
            this.getList()
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    // 接受，面试
    getResumeStatus(id, status) {
      let params = {
        id: id,
        status: status,
      };
      this.$httpStudent.axiosPost(
        this.$api.resumeChangeInterviewStatus,
        params,
        (res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.getList()
            this.$emit("changeNUmber");
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    // 查看公司详情
    getCompanyDetial(id){
        this.$router.push({path:"/student/recruitmentCenter/companyDetial",query:{id:id}})
        // student/recruitmentCenter/companyDetial?id=5
    }
  },
};
</script>
<style lang='scss' scoped>
.no_data {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
}
.list {
  .detial_item {
    width: 100%;
    margin-bottom: 20px;
    .header {
      height: 48px;
      background: #fcfbfa;
      border-radius: 12px 12px 0px 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 23px;
      box-sizing: border-box;
      .name {
        display: flex;
        align-items: center;
        .status {
          width: 86px;
          height: 24px;
          background: #fff4e8;
          border-radius: 4px 4px 4px 4px;
          font-weight: 400;
          font-size: 14px;
          color: #ff941c;
          margin-left: 15px;
          text-align: center;
          line-height: 24px;
        }
        .no_status {
          background: #ffeae8;
          color: #ff361c;
        }
      }
      .button {
        width: 88px;
        height: 32px;
        background: #685ef5;
        border-radius: 8px 8px 8px 8px;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
      }
      .border_button {
        border: 1px solid #685ef5;
        background: #fcfbfa;
        color: #685ef5;
      }
      .button_box {
        display: flex;
        align-items: center;
      }
    }
    .content_box {
      height: 88px;
      background: #ffffff;
      border-radius: 0px 0px 12px 12px;
      padding: 15px 23px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left_box {
        .job_name {
          font-weight: 400;
          font-size: 16px;
          color: #222222;
          margin-bottom: 13px;
        }
        .more_detial {
          display: flex;
          align-items: center;
          .number {
            font-weight: 400;
            font-size: 14px;
            color: #fe574a;
            margin-right: 15px;
          }
          .image_box {
            width: 18px;
            height: 18px;
            border-radius: 2px 2px 2px 2px;
            margin-right: 5px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 2px;
              object-fit: cover;
            }
          }
          .background_label {
            font-weight: 400;
            font-size: 14px;
            height: 22px;
            display: inline-block;
            color: #666666;
            background: #f8f8f8;
            border-radius: 4px 4px 4px 4px;
            margin-right: 15px;
            padding: 0 6px;
          }
        }
      }
      .right_box {
        display: flex;
        .right_image_box {
          width: 56px;
          height: 56px;
          background: #d9d9d9;
          border-radius: 4px 4px 4px 4px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }
        }
      }
      .right_resume_box {
        color: #666666;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: end;
        .time {
          margin-top: 10px;
        }
      }
    }
  }
}
.pagination {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #685ef5;
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
